import i18next from 'i18next'
import { parseDate } from '../../../../../config/dayjsConfig'
import { ReportDataType } from '../../../../../redux/context/reports/types'
import { appTheme } from '../../../../../config/appTheme'
import { CustomReportCategory } from '../../../../../redux/context/customReports/typesCategory'
import { CustomReportVariable } from '../../../../../redux/context/customReports/typesVariable'
import { evaluateReferenceValueRule } from '../../../keyFigures/utils'
import { VariableType } from '../../../../../components/Table/types'

export type TranslatableTitle = {
  name?: string
  translation?: string
  nameFi?: string
  nameEn?: string
  nameSv?: string
}
export const getTitleByLanguage = (row: TranslatableTitle) => {
  if (i18next.language === 'fi' && row.nameFi) return row.nameFi
  if (i18next.language === 'en' && row.nameEn) return row.nameEn
  if (i18next.language === 'sv' && row.nameSv) return row.nameSv
  return row.name ?? (row.translation ? i18next.t(row.translation, '') : '')
}

export function extractDate(dateTimeString?: string) {
  if (!dateTimeString) return null
  // Define the regex pattern to match the date portion
  const pattern = /(\d{4}-\d{2}-\d{2})/

  // Use the match method to extract the date portion
  const match = dateTimeString.match(pattern)

  // If a match is found, extract the date part
  if (match) {
    return match[0] // Return the matched date portion
  }

  return null // Return null if no match is found (optional)
}

export const normalizeValue = (
  object: { startDate?: string; endDate?: string },
  value?: number
): number | undefined => {
  const { startDate, endDate } = object

  if (!startDate || !endDate || !value) {
    return value
  }

  const start = parseDate(extractDate(startDate))
  const end = parseDate(extractDate(endDate))

  if (!start || !end) {
    return value
  }

  const monthsDifference = end.diff(start, 'month', true)

  return value / Math.abs(monthsDifference)
}

const getReferenceValueRuleColor = (
  category: CustomReportCategory,
  variable: CustomReportVariable,
  value: number
): string | undefined => {
  const ignoredFunctions = ['diff', 'growth', 'commonSize', 'division', 'div']
  if (!variable?.style?.referenceValueRules || ignoredFunctions.includes(category.value as string)) {
    return undefined
  }

  const compareValue = variable?.type === VariableType.absolute ? normalizeValue(category, value) : value
  const foundRule = variable.style?.referenceValueRules?.find(rule => evaluateReferenceValueRule(rule, compareValue))
  return foundRule?.color
}

export const getColumnColor = (category?: CustomReportCategory, variable?: CustomReportVariable, value?: number) => {
  if (!category) return undefined

  const { budgetingScenario: { forecastCursor } = {}, startDate, color: categoryColor } = category

  if (variable != null && value != null) {
    const referenceRuleColor = getReferenceValueRuleColor(category, variable, value)
    if (referenceRuleColor) return referenceRuleColor
  }

  if (categoryColor) return categoryColor

  if (category.dataType === ReportDataType.budget) {
    return appTheme.budgetColor
  }

  if (forecastCursor) {
    const cursor = parseDate(forecastCursor)
    const start = parseDate(startDate)
    return cursor && start && cursor.valueOf() > start.valueOf() ? appTheme.forecastActualColor : appTheme.forecastColor
  }

  return undefined
}

export const showArrow = (value: number | undefined, category: CustomReportCategory, record: CustomReportVariable) => {
  if (
    value &&
    +value !== 0 &&
    (category.value === 'growth' || category.value === 'diff') &&
    record?.style?.thresholdValueSetting
  ) {
    return true
  }
  return false
}
